import { Typography } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { PersonIdentification } from "../../../../models/Shared/PersonIdentification";

interface IProps {
  personIdentification?: PersonIdentification;
  userOib: string;
}

export const AlternativeDocumentInfo = ({
  personIdentification,
  userOib,
}: IProps) => {
  const { t } = useTranslation();

  if (userOib) {
    return null;
  }

  return (
    <Row className="alternative-document-info mb-2">
      <Col md={4}>
        <div className="form-group">
          <Typography variant="small" className="text-muted">
            {t("person.alternativeDocumentNumber")}
          </Typography>
          <Typography variant="base">
            {personIdentification?.alternativeDocumentNumber}
          </Typography>
        </div>
      </Col>
      <Col md={4}>
        <div className="form-group">
          <Typography variant="small" className="text-muted">
            {t("person.alternativeDocumentType")}
          </Typography>
          <Typography variant="base">
            {personIdentification?.alternativeDocumentTypeId}
          </Typography>
        </div>
      </Col>
      <Col md={4}>
        <div className="form-group">
          <Typography variant="small" className="text-muted">
            {t("person.alternativeDocumentReason")}
          </Typography>
          <Typography variant="base">
            {personIdentification?.alternativeDocumentReasonId}
          </Typography>
        </div>
      </Col>
    </Row>
  );
};
